import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaign-payments-empty-invoice.scss';

applyTranslations(require('./ccm-campaign-payments-empty-invoice.i18n.json'));

const CcmCampaignPaymentsEmptyInvoice = () => (
  <div className="ccm-campaign-payments-empty-invoice">
    {__t('ccm_campaign_payments_empty_invoice.message')}
  </div>
);

export default CcmCampaignPaymentsEmptyInvoice;
